import { watchOnce } from '@vueuse/core';
import { useNavKillswitch } from '~/stores/navKillswitch';
import { storeToRefs } from 'pinia';

export default function onKsFlagsReady(cb) {
  const navKillswitch = useNavKillswitch();
  const { isFlags } = storeToRefs(navKillswitch);

  if (isFlags.value) {
    cb();
    return;
  }

  watchOnce(isFlags, cb);
}

export async function onKsFlagsFetched(cb) {
  const navKillswitch = useNavKillswitch();

  // client side only
  if (typeof window !== 'undefined') {
    await navKillswitch.fetch();
  }

  cb();
}
